import {AUTH_URL, USERS_URL} from '../constants';
import { apiSlice } from './apiSlice';

export const userApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (data) => ({
                url: `${USERS_URL}/login`,
                method: 'POST',
                body: data,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            }),
        }),
        getProfile: builder.query({
            query: () => ({
                url: `${USERS_URL}/me`, // should match your backend route
                credentials: 'include',
            }),
        }),
        refresh: builder.query({
            query: () => ({
                url: `${USERS_URL}/refresh`,
                method: 'GET',
                credentials: 'include', // necessary to send the cookie
            }),
        }),
        register: builder.mutation({
            query: (data) => ({
                url: `${USERS_URL}`,
                method: 'POST',
                body: data,
            }),
        }),
        logout: builder.mutation({
            query: () => ({
                url: `${USERS_URL}/logout`,
                method: 'POST',
            }),
        }),
        profile: builder.mutation({
            query: (data) => ({
                url: `${USERS_URL}/profile`,
                method: 'PUT',
                body: data,
            }),
        }),
        getUsers: builder.query({
            query: ({ pageNumber, keyword, isAdmin, isClient, type }) => ({
                url: `${USERS_URL}`,
                method: 'GET',
                params: { pageNumber, keyword, isAdmin, isClient, type },
            }),
            providesTags: ['Users'],
            keepUnusedDataFor: 5,
        }),
        deleteUser: builder.mutation({
            query: (userId) => ({
                url: `${USERS_URL}/${userId}`,
                method: 'DELETE',
            }),
        }),
        getUserDetails: builder.query({
            query: (userId) => ({
                url: `${USERS_URL}/${userId}`,
            }),
            keepUnusedDataFor: 5,
        }),
        updateUser: builder.mutation({
            query: (data) => ({
                url: `${USERS_URL}/${data.userId}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['Users'],
        }),
        addUserAddress: builder.mutation({
            query: ({ userId, address }) => ({
                url: `${USERS_URL}/${userId}/addresses`,
                method: 'POST',
                body: address,
            }),
        }),
        getDefaultAddress: builder.query({
            query: (userId) => `${USERS_URL}/${userId}/addresses/default`,
        }),
        getAddressesByUser: builder.query({
            query: (userId) => ({
                url: `${USERS_URL}/${userId}/addresses`,
                method: 'GET',
            }),
        }),
        getAdminAddressesByUser: builder.query({
            query: (userId) => ({
                url: `${USERS_URL}/${userId}/admin-addresses`,
                method: 'GET',
            }),
        }),
        updateUserAddress: builder.mutation({
            query: ({ userId, addressId, body }) => ({
                url: `${USERS_URL}/${userId}/addresses/${addressId}`,
                method: 'PUT',
                body,
            }),
        }),
        updateAdminUserAddress: builder.mutation({
            query: ({ userId, body }) => ({
                url: `${USERS_URL}/${userId}/admin-addresses`,
                method: 'PUT',
                body,
            }),
        }),
        forgotPassword: builder.mutation({
            query: (data) => ({
                url: `${AUTH_URL}/forgot-password`,
                method: 'POST',
                body: data,
            }),
        }),
        resetPassword: builder.mutation({
            query: (data) => ({
                url: `${AUTH_URL}/reset-password`,
                method: 'POST',
                body: data,
            }),
        }),
    }),
});

export const {
    useLoginMutation,
    useGetProfileQuery,
    useLazyRefreshQuery,
    useRegisterMutation,
    useLogoutMutation,
    useProfileMutation,
    useGetUsersQuery,
    useDeleteUserMutation,
    useGetUserDetailsQuery,
    useUpdateUserMutation,
    useAddUserAddressMutation,
    useGetDefaultAddressQuery,
    useGetAddressesByUserQuery,
    useGetAdminAddressesByUserQuery,
    useUpdateUserAddressMutation,
    useUpdateAdminUserAddressMutation,
    useForgotPasswordMutation,
    useResetPasswordMutation,
} = userApiSlice;
